/* eslint-disable no-unexpected-multiline */
import {apiEndpoints} from 'utils/apis';
import api from './Index';

// Define the structure of an API Call
interface ApiCall {
  method: 'GET' | 'POST' | 'PUT' | 'DELETE';
  endpoint: string;
  data?: any;
  params?: any;
  id?: number | string;
  responseType?: string; // optional: for blob, json, etc.
}
// Generic CRUD Function
const genericApiCall = async ({
  method,
  endpoint,
  data,
  params,
  id,
  responseType,
}: ApiCall): Promise<unknown> => {
  const url = id != null ? `${endpoint}?id=${id}` : endpoint;
  return await new Promise((resolve, reject) => {
    (api as any)
      [method.toLowerCase()](url, data, {params})
      .then((response: any) => {
        resolve(response.data);
      })
      .catch((error: any) => {
        reject(error);
      });
  });
};

// Define individual calls using the new structure
const ApiUtils = {
  authLogin: async (params: any) =>
    await genericApiCall({
      method: 'POST',
      endpoint: apiEndpoints.LOGIN,
      data: params,
    }),

  updateDeviceToken: async (params: any) =>
    await genericApiCall({
      method: 'POST',
      endpoint: apiEndpoints.UPDATE_DEVICE_TOKEN,
      data: params,
    }),

  updateNotificationStatus: async (params: any) =>
    await genericApiCall({
      method: 'POST',
      endpoint: apiEndpoints.UPDATE_NOTIFICATION_STATUS,
      data: params,
    }),

  getCountryCode: async () =>
    await genericApiCall({
      method: 'GET',
      endpoint: `${apiEndpoints.GET_COUNTRY_CODE}`,
    }),

  getVenueList: async (params: any) =>
    await genericApiCall({
      method: 'GET',
      endpoint: `${apiEndpoints.VENUE_LISTING}${params}`,
    }),
  addVenue: async (params: any) =>
    await genericApiCall({
      method: 'POST',
      endpoint: apiEndpoints.ADD_VENUE,
      data: params,
    }),
  updateVenue: async (params: any) => {
    console.log('🚀 ~ params:', params);
    return await genericApiCall({
      method: 'POST',
      endpoint: apiEndpoints.UPDATE_VENUE,
      data: params,
    });
  },
  deleteVenue: async (params: any) => {
    console.log('🚀 ~ deleteVenue: ~ params:', params);
    return await genericApiCall({
      method: 'DELETE',
      endpoint: `${apiEndpoints.DELETE_VENUE}/${params}`,
    });
  },
  TypeVenue: async () =>
    await genericApiCall({
      method: 'GET',
      endpoint: apiEndpoints.TYPE_VENUE,
    }),
  getSuggestedVenueList: async (params: any) =>
    await genericApiCall({
      method: 'GET',
      endpoint: `${apiEndpoints.SUGGESTED_VENUE_LISTING}${params}`,
    }),
  getEventList: async (params: any, requestBody: any) =>
    await genericApiCall({
      method: 'POST',
      endpoint: `${apiEndpoints.EVENT_LISTING}${params}`,
      data: {venue_id: requestBody},
    }),
  getEventListByVenue: async (params: any, requestBody: any) =>
    await genericApiCall({
      method: 'POST',
      endpoint: `${apiEndpoints.EVENT_LISTING}${params}`,
      data: {venue_id: requestBody},
    }),
  addEvent: async (params: any) =>
    await genericApiCall({
      method: 'POST',
      endpoint: apiEndpoints.ADD_EVENT,
      data: params,
    }),
  updateEvent: async (params: any) => {
    console.log('🚀 ~ params:', params);
    return await genericApiCall({
      method: 'POST',
      endpoint: apiEndpoints.UPDATE_EVENT,
      data: params,
    });
  },
  updateEventStatus: async (params: any) => {
    console.log('🚀 ~ params:', params);
    return await genericApiCall({
      method: 'POST',
      endpoint: apiEndpoints.UPDATE_EVENT_STATUS,
      data: params,
    });
  },
  deleteEvent: async (params: any) => {
    return await genericApiCall({
      method: 'DELETE',
      endpoint: `${apiEndpoints.DELETE_EVENT}/${params}`,
    });
  },
  getAfterPartyList: async (params: any) =>
    await genericApiCall({
      method: 'GET',
      endpoint: `${apiEndpoints.AFTER_PARTY_LISTING}${params}`,
    }),
  addAfterParty: async (params: any) =>
    await genericApiCall({
      method: 'POST',
      endpoint: apiEndpoints.ADD_AFTER_PARTY,
      data: params,
    }),
  updateAfterParty: async (params: any) => {
    return await genericApiCall({
      method: 'POST',
      endpoint: apiEndpoints.UPDATE_AFTER_PARTY,
      data: params,
    });
  },
  deleteAfterParty: async (params: any) => {
    return await genericApiCall({
      method: 'DELETE',
      endpoint: `${apiEndpoints.DELETE_AFETR_PARTY}/${params}`,
    });
  },

  getGuestList: async (params: any, requestBody: any) => {
    console.log('🚀 ~ getGuestListByFilter: ~ requestBody:', requestBody);
    return await genericApiCall({
      method: 'POST',
      endpoint: `${apiEndpoints.GUEST_LISTING}${params}`,
      data: requestBody,
    });
  },

  getGuestExport: async (params: any) => {
    return await genericApiCall({
      method: 'POST',
      endpoint: apiEndpoints.EXPORT_GUEST,
      data: params,
      responseType: 'blob',
    });
  },

  getBookTableList: async (params: any, requestBody: any) => {
    // console.log('🚀 ~ getGuestListByFilter: ~ requestBody:', requestBody);
    return await genericApiCall({
      method: 'POST',
      endpoint: `${apiEndpoints.BOOK_TABLE_LISTING}${params}`,
      data: requestBody,
    });
  },
  updateGuestStatus: async (params: any) => {
    return await genericApiCall({
      method: 'POST',
      endpoint: apiEndpoints.UPDATE_GUEST_STATUS,
      data: params,
    });
  },
  updateBookTableStatus: async (params: any) => {
    return await genericApiCall({
      method: 'POST',
      endpoint: apiEndpoints.UPDATE_BOOK_TABLE_STATUS,
      data: params,
    });
  },
  getFestivalList: async (params: any) =>
    await genericApiCall({
      method: 'GET',
      endpoint: `${apiEndpoints.FESTIVAL_LISTING}${params}`,
    }),
  addFestival: async (params: any) =>
    await genericApiCall({
      method: 'POST',
      endpoint: apiEndpoints.ADD_FESTIVAL,
      data: params,
    }),
  updateFestival: async (params: any) => {
    return await genericApiCall({
      method: 'POST',
      endpoint: apiEndpoints.UPDATE_FESTIVAL,
      data: params,
    });
  },
  deleteFestival: async (params: any) => {
    return await genericApiCall({
      method: 'DELETE',
      endpoint: `${apiEndpoints.DELETE_FESTIVAL}/${params}`,
    });
  },
  getSuggestedFestivalList: async (params: any) =>
    await genericApiCall({
      method: 'GET',
      endpoint: `${apiEndpoints.SUGGESTED_FESTIVAL_LISTING}${params}`,
    }),

  getUtmSoucreList: async (params: any) =>
    await genericApiCall({
      method: 'GET',
      endpoint: `${apiEndpoints.UTM_SOURCE_LIST}${params}`,
    }),

  getUsersList: async (
    params: any,
    utmSource: any[] = [],
    utmCampaign: any[] = [],
  ) =>
    await genericApiCall({
      method: 'POST',
      endpoint: `${apiEndpoints.USERS_LISTING}${params}`,
      data: {utm_source: utmSource, utm_campaign: utmCampaign},
    }),

  getApprovedGuestsList: async (
    params: any,
    utmSource: any[] = [],
    utmCampaign: any[] = [],
  ) =>
    await genericApiCall({
      method: 'POST',
      endpoint: `${apiEndpoints.USERS_LISTING}${params}`,
      data: {utm_source: utmSource, utm_campaign: utmCampaign},
    }),

  getGuestsWaitList: async (params: any) =>
    await genericApiCall({
      method: 'POST',
      endpoint: `${apiEndpoints.USERS_LISTING}${params}`,
    }),

  addUser: async (params: any) =>
    await genericApiCall({
      method: 'POST',
      endpoint: apiEndpoints.ADD_USER,
      data: params,
    }),
  updateUser: async (params: any) => {
    console.log('🚀 ~ updateUser: ~ params:', params);
    return await genericApiCall({
      method: 'POST',
      endpoint: apiEndpoints.UPDATE_USER,
      data: params,
    });
  },
  deleteUser: async (params: any) => {
    return await genericApiCall({
      method: 'DELETE',
      endpoint: `${apiEndpoints.DELETE_USER}/${params}`,
    });
  },
  updateUserStatus: async (params: any) => {
    console.log('🚀 ~ updateUser: ~ params:', params);
    return await genericApiCall({
      method: 'POST',
      endpoint: apiEndpoints.UPDATE_USER_STATUS,
      data: params,
    });
  },
  getPendingUserList: async (params: any) =>
    await genericApiCall({
      method: 'GET',
      endpoint: `${apiEndpoints.PENDING_USERS}${params}`,
    }),
  updatePendingUserStatus: async (params: any) => {
    console.log('🚀 ~ updateUser: ~ params:', params);
    return await genericApiCall({
      method: 'POST',
      endpoint: apiEndpoints.UPDATE_PENDING_USER_STATUS,
      data: params,
    });
  },
  updatePendingGuestsUserStatus: async (params: any) => {
    console.log('🚀 ~ updateUser: ~ params:', params);
    return await genericApiCall({
      method: 'POST',
      endpoint: apiEndpoints.UPDATE_PENDING_USER_STATUS,
      data: params,
    });
  },
  getDressCodeList: async () =>
    await genericApiCall({
      method: 'GET',
      endpoint: `${apiEndpoints.DRESS_CODE_LISTING}`,
    }),

  getDashBoardCount: async () =>
    await genericApiCall({
      method: 'GET',
      endpoint: `${apiEndpoints.DASHBOARD_COUNT}`,
    }),

  getNewRegisterUsersData: async (params: any) =>
    await genericApiCall({
      method: 'GET',
      endpoint: `${apiEndpoints.NEW_USER_REGISTER}/${params}`,
      params,
    }),
  getNewRegisterVenuesData: async (params: any) =>
    await genericApiCall({
      method: 'GET',
      endpoint: `${apiEndpoints.NEW_VENUE_REGISTER}/${params}`,
      params,
    }),

  getNotificationlList: async () =>
    await genericApiCall({
      method: 'GET',
      endpoint: `${apiEndpoints.NOTIFICATION_LISTING}`,
    }),

  addClubProfile: async (params: any) =>
    await genericApiCall({
      method: 'POST',
      endpoint: apiEndpoints.ADD_CLUB_PROFILE,
      data: params,
    }),
  getClub: async (params: any) =>
    await genericApiCall({
      method: 'POST',
      endpoint: `${apiEndpoints.GET_CLUB}`,
      data: params,
    }),
  getClubProfileList: async (params: any, requestBody: any) =>
    await genericApiCall({
      method: 'POST',
      endpoint: `${apiEndpoints.CLUB_PROFILE_LISTING}${params}`,
      data: {venue_id: requestBody},
    }),
  deleteClubProfile: async (params: any) => {
    return await genericApiCall({
      method: 'DELETE',
      endpoint: `${apiEndpoints.DELETE_CLUB_PROFILE}/${params}`,
    });
  },

  addRestaurantProfile: async (params: any) =>
    await genericApiCall({
      method: 'POST',
      endpoint: apiEndpoints.ADD_RESTAURANT_PROFILE,
      data: params,
    }),
  getRestaurantProfileList: async (params: any, requestBody: any) =>
    await genericApiCall({
      method: 'POST',
      endpoint: `${apiEndpoints.RESTAURANT_PROFILE_LISTING}${params}`,
      data: {venue_id: requestBody},
    }),
  deleteRestaurantProfile: async (params: any) => {
    return await genericApiCall({
      method: 'DELETE',
      endpoint: `${apiEndpoints.DELETE_RESTAURANT_PROFILE}/${params}`,
    });
  },

  getRestaurantBookTableList: async (params: any, requestBody: any) => {
    return await genericApiCall({
      method: 'POST',
      endpoint: `${apiEndpoints.RESTAURANT_BOOK_TABLE_LISTING}${params}`,
      data: requestBody,
    });
  },
  updateRestaurantBookTableStatus: async (params: any) => {
    return await genericApiCall({
      method: 'POST',
      endpoint: apiEndpoints.UPDATE_RESTAURANT_BOOK_TABLE_STATUS,
      data: params,
    });
  },

  checkRestaurantNameAvailability: async (params: any) =>
    await genericApiCall({
      method: 'POST',
      endpoint: `${apiEndpoints.CHECK_RESTAURANT_NAME}`,
      data: params,
    }),
  checkClubNameAvailability: async (params: any) =>
    await genericApiCall({
      method: 'POST',
      endpoint: `${apiEndpoints.CHECK_CLUB_NAME}`,
      data: params,
    }),

  updateRestaurantStatus: async (params: any) => {
    return await genericApiCall({
      method: 'POST',
      endpoint: apiEndpoints.UPDATE_RESTAURANT_STATUS,
      data: params,
    });
  },
  updateClubStatus: async (params: any) => {
    return await genericApiCall({
      method: 'POST',
      endpoint: apiEndpoints.UPDATE_CLUB_STATUS,
      data: params,
    });
  },
  getEventEngagementChart: async () =>
    await genericApiCall({
      method: 'GET',
      endpoint: `${apiEndpoints.GET_EVENT_ENGAGEMENT_CHART}`,
    }),

  getMostPopularEventData: async () =>
    await genericApiCall({
      method: 'GET',
      endpoint: `${apiEndpoints.GET_MOST_POPULAR_EVENT_CHART}`,
    }),

  getVenuePerformanceData: async (params: any) =>
    await genericApiCall({
      method: 'GET',
      endpoint: `${apiEndpoints.GET_VENUE_PERFORMANCE_DATA}${params}`,
      params,
    }),

  getGuestListEngagement: async () =>
    await genericApiCall({
      method: 'GET',
      endpoint: `${apiEndpoints.GET_GUEST_LIST_ENGAGEMENT_DATA}`,
    }),

  getRetentionChurnData: async (params: any) =>
    await genericApiCall({
      method: 'GET',
      endpoint: `${apiEndpoints.GET_RETENTION_CHURN_CHART}/${params}`,
      params,
    }),

  getEngagementMetricsData: async (params: any) =>
    await genericApiCall({
      method: 'GET',
      endpoint: `${apiEndpoints.GET_ENGAGEMENT_METRICS}/${params}`,
      params,
    }),

  // getVenueList: async (params: any) =>
  //   await genericApiCall({
  //     method: 'GET',
  //     endpoint: `${apiEndpoints.VENUE_LISTING}${params}`,
  //   }),
  verifyOTP: async (params: any) =>
    await genericApiCall({
      method: 'POST',
      endpoint: apiEndpoints.VERIFY_OTP,
      data: params,
    }),
  forgetPassword: async (params: any) =>
    await genericApiCall({
      method: 'POST',
      endpoint: apiEndpoints.FORGET_PASSWORD,
      data: params,
    }),
  resetPassword: async (params: any) =>
    await genericApiCall({
      method: 'POST',
      endpoint: apiEndpoints.RESET_PASSWORD,
      data: params,
    }),
  getProfile: async () =>
    await genericApiCall({
      method: 'GET',
      endpoint: apiEndpoints.GET_PROFILE,
    }),
  updateProfile: async (params: any) =>
    await genericApiCall({
      method: 'POST',
      endpoint: apiEndpoints.UPDATE_PROFILE,
      data: params,
    }),
  sendActivationCode: async (params: any) =>
    await genericApiCall({
      method: 'POST',
      endpoint: apiEndpoints.SEND_ACTIVATION_CODE,
      data: params,
    }),
  addProduct: async (params: any) =>
    await genericApiCall({
      method: 'POST',
      endpoint: apiEndpoints.CREATE_PRODUCT,
      data: params,
    }),
  updateProduct: async (params: any) =>
    await genericApiCall({
      method: 'POST',
      endpoint: apiEndpoints.UPDATE_PRODUCT,
      data: params,
    }),
  getProduct: async (productId: string) =>
    await genericApiCall({
      method: 'GET',
      endpoint: apiEndpoints.GET_PRODUCT + `/${productId}`,
    }),
  createBrand: async (params: any) => {
    return await genericApiCall({
      method: 'POST',
      endpoint: apiEndpoints.CREATE_BRAND,
      data: params,
    });
  },
  updateBrand: async (params: any) => {
    return await genericApiCall({
      method: 'POST',
      endpoint: apiEndpoints.UPDATE_BRAND,
      data: params,
    });
  },
  brandList: async (params: any) =>
    await genericApiCall({
      method: 'GET',
      endpoint: `${apiEndpoints.LIST_BRAND}?${params}`,
    }),
  deletebrand: async (params: any) =>
    await genericApiCall({
      method: 'DELETE',
      endpoint: `${apiEndpoints.DELETE_BRAND}?${params}`,
    }),
  getBrand: async () =>
    await genericApiCall({
      method: 'GET',
      endpoint: apiEndpoints.GET_BRAND,
    }),
  getBrandByCategory: async (params: any) =>
    await genericApiCall({
      method: 'GET',
      endpoint: `${apiEndpoints.GET_BRAND_BY_CATEGORY}?id=${params}`,
      params,
    }),

  couponMediaType: async () =>
    await genericApiCall({
      method: 'GET',
      endpoint: apiEndpoints.GET_COUPON_MEDIA_TYPE,
    }),
  addProductOption: async (params: any) =>
    await genericApiCall({
      method: 'POST',
      endpoint: apiEndpoints.CREATE_PRODUCT_OPTION,
      data: params,
    }),
  editProductOption: async (params: any) =>
    await genericApiCall({
      method: 'POST',
      endpoint: apiEndpoints.UPDATE_PRODUCT_OPTION,
      data: params,
    }),
  deleteProductOption: async (params: any) =>
    await genericApiCall({
      method: 'DELETE',
      endpoint: apiEndpoints.DELETE_PRODUCT_OPTION,
      id: params,
    }),
  getProductOptionsById: async (optionId: string) =>
    await genericApiCall({
      method: 'GET',
      endpoint: apiEndpoints.GET_OPTION_VALUE_BY_ID + `&option_id=${optionId}`,
    }),
  getOptionsById: async (optionId: string) =>
    await genericApiCall({
      method: 'GET',
      endpoint: apiEndpoints.GET_OPTIONS_BY_ID + `/${optionId}`,
    }),
  getGstTax: async () =>
    await genericApiCall({
      method: 'GET',
      endpoint: apiEndpoints.GET_GST_TAX,
    }),
  getCategory: async () =>
    await genericApiCall({
      method: 'GET',
      endpoint: apiEndpoints.GET_CATEGORY,
    }),
  getOptions: async () =>
    await genericApiCall({
      method: 'GET',
      endpoint: apiEndpoints.GET_OPTIONS,
    }),
  getWeightLength: async () =>
    await genericApiCall({
      method: 'GET',
      endpoint: apiEndpoints.GET_WEIGHT_LENGTH,
    }),
  getOptionValue: async (optionId: string) =>
    await genericApiCall({
      method: 'GET',
      endpoint: apiEndpoints.GET_OPTION_VALUE + `&option_id=${optionId}`,
    }),
  getProductList: async (params: any) => {
    return await genericApiCall({
      method: 'GET',
      endpoint: `${apiEndpoints.PRODUCT_LIST}${params}`,
    });
  },
  getProductById: async (params: any) =>
    await genericApiCall({
      method: 'GET',
      endpoint: `${apiEndpoints.PRODUCT_LIST_BY_ID}/${params}`,
    }),
  deleteProduct: async (params: any) =>
    await genericApiCall({
      method: 'DELETE',
      endpoint: apiEndpoints.DELETE_PRODUCT,
      id: params,
    }),
  addCategory: async (params: any) =>
    await genericApiCall({
      method: 'POST',
      endpoint: apiEndpoints.ADD_CATEGORY,
      data: params,
    }),
  getStatus: async (params: any) =>
    await genericApiCall({
      method: 'GET',
      endpoint: `${apiEndpoints.GET_STATUS}?${params}`,
      params,
    }),

  updateCategory: async (params: any) =>
    await genericApiCall({
      method: 'POST',
      endpoint: apiEndpoints.UPDATE_CATEGORY,
      data: params,
    }),
  getCategoryList: async (params: any) =>
    await genericApiCall({
      method: 'GET',
      endpoint: `${apiEndpoints.CATEGORY_LISTING}${params}`,
    }),
  deleteCategory: async (params: any) =>
    await genericApiCall({
      method: 'DELETE',
      endpoint: apiEndpoints.DELETE_CATEGORY,
      id: params,
    }),
  createHsn: async (params: any) =>
    await genericApiCall({
      method: 'POST',
      endpoint: apiEndpoints.CREATE_HSN,
      data: params,
    }),
  updateHsn: async (params: any) =>
    await genericApiCall({
      method: 'POST',
      endpoint: apiEndpoints.UPDATE_HSN,
      data: params,
    }),
  getHSNList: async (params: any) =>
    await genericApiCall({
      method: 'GET',
      endpoint: `${apiEndpoints.HSN_LISTING}${params}`,
    }),
  deleteHSN: async (params: any) =>
    await genericApiCall({
      method: 'DELETE',
      endpoint: apiEndpoints.HSN_DELETE,
      id: params,
    }),

  getOrderList: async (params: any) => {
    return await genericApiCall({
      method: 'GET',
      endpoint: `${apiEndpoints.GET_ORDERLIST}${params}`,
    });
  },
  getPaymentTrackingList: async (params: any) => {
    return await genericApiCall({
      method: 'GET',
      endpoint: `${apiEndpoints.GET_PAYMENT_TRACKING}${params}`,
    });
  },
  getProductStockList: async (params: any) => {
    return await genericApiCall({
      method: 'POST',
      endpoint: apiEndpoints.GET_STOCK,
      data: params,
    });
  },
  getProductByCategoryId: async (params: any) => {
    return await genericApiCall({
      method: 'POST',
      endpoint: apiEndpoints.GET_PRODUCT_BY_CATEGORY_ID,
      data: params,
    });
  },
  getOptionByProductById: async (params: any) => {
    return await genericApiCall({
      method: 'POST',
      endpoint: apiEndpoints.GET_OPTION_BY_PRODUCT_ID,
      data: params,
    });
  },
  getOptionValueByOptionId: async (params: any) => {
    return await genericApiCall({
      method: 'POST',
      endpoint: apiEndpoints.GET_OPTION_VALUE_BY_OPTION_ID,
      data: params,
    });
  },
  updateOrderStatus: async (params: any) => {
    return await genericApiCall({
      method: 'POST',
      endpoint: apiEndpoints.UPDATE_ORDER_STATUS,
      data: params,
    });
  },
  getPolicyList: async (params: any) => {
    return await genericApiCall({
      method: 'GET',
      endpoint: `${apiEndpoints.GET_POLICY_LIST}?${params}`,
    });
  },
  getRecentOrders: async () => {
    return await genericApiCall({
      method: 'GET',
      endpoint: `${apiEndpoints.GET_ORDERLIST}?${`sort_direction=desc`}`,
    });
  },
  getDasbordData: async (params: any) =>
    await genericApiCall({
      method: 'GET',
      endpoint: `${apiEndpoints.GET_DASHBOARD_DATA}?${params}`,
    }),
  getCouponAnalysisList: async (params: any) => {
    return await genericApiCall({
      method: 'GET',
      endpoint: `${apiEndpoints.GET_COUPON_ANALYSIS}${params}`,
    });
  },
  getOrderCount: async () => {
    return await genericApiCall({
      method: 'GET',
      endpoint: apiEndpoints.ORDER_COUNT,
    });
  },
  getDeliveryPerson: async (params: any) => {
    return await genericApiCall({
      method: 'GET',
      endpoint: `${apiEndpoints.GET_DELIVERY_PERSON}?${params}`,
    });
  },
  createDeliveryPerson: async (params: any) => {
    return await genericApiCall({
      method: 'POST',
      endpoint: apiEndpoints.CREATE_DELIVERY_PERSON,
      data: params,
    });
  },
  updateDeliveryPerson: async (params: any) => {
    return await genericApiCall({
      method: 'POST',
      endpoint: apiEndpoints.UPDATE_DELIVERY_PERSON,
      data: params,
    });
  },
  deleteDeliveryPerson: async (params: any) => {
    return await genericApiCall({
      method: 'DELETE',
      endpoint: `${apiEndpoints.DELETE_DELEVERY_PERSON}?${params}`,
    });
  },
  getDiscountList: async (params: any) =>
    await genericApiCall({
      method: 'GET',
      endpoint: `${apiEndpoints.GET_DISCOUNT}${params}`,
    }),
  createDiscount: async (params: any) =>
    await genericApiCall({
      method: 'POST',
      endpoint: apiEndpoints.CREATE_DISCOUNT,
      data: params,
    }),

  updateDiscount: async (params: any) =>
    await genericApiCall({
      method: 'POST',
      endpoint: apiEndpoints.UPDATE_DISCOUNT,
      data: params,
    }),
  deleteDiscount: async (params: any) =>
    await genericApiCall({
      method: 'DELETE',
      endpoint: apiEndpoints.DELETE_DISCOUNT,
      id: params,
    }),
  updateHeaderStatus: async (params: any) => {
    return await genericApiCall({
      method: 'POST',
      endpoint: apiEndpoints.UPDATE_HEADER_STATUS,
      data: params,
    });
  },
  downloadSalesReport: async (params: any) =>
    await genericApiCall({
      method: 'GET',
      endpoint: `${apiEndpoints.GET_SALES_REPORT}?${params}`,
    }),
  assignDeliveryPerson: async (params: any) =>
    await genericApiCall({
      method: 'POST',
      endpoint: apiEndpoints.ASSIGN_DELIVERY_PERSON,
      data: params,
    }),
  getTeplates: async (params: any) =>
    await genericApiCall({
      method: 'GET',
      endpoint: `${apiEndpoints.GET_TEMPLATE}?${params}`,
    }),
  deleteTeplate: async (params: any) =>
    await genericApiCall({
      method: 'DELETE',
      endpoint: `${apiEndpoints.DELETE_TEMPLETE}?${params}`,
    }),
  createTeplate: async (params: any) =>
    await genericApiCall({
      method: 'POST',
      endpoint: apiEndpoints.CREATE_TEPLATE,
      data: params,
    }),
  updateTamplate: async (params: any) =>
    await genericApiCall({
      method: 'POST',
      endpoint: apiEndpoints.UPDATE_TEPLATE,
      data: params,
    }),
  updateProductStatus: async (params: any) =>
    await genericApiCall({
      method: 'POST',
      endpoint: apiEndpoints.UPDATE_PRODUCT_STATUS,
      data: params,
    }),
  priceComparision: async (params: any) =>
    await genericApiCall({
      method: 'GET',
      endpoint: `${apiEndpoints.PRICE_COMPARISION}?${params}`,
    }),
  updateCategoryStatus: async (params: any) =>
    await genericApiCall({
      method: 'POST',
      endpoint: apiEndpoints.UPDATE_CATEGORY_STATUS,
      data: params,
    }),
  cancelOrder: async (params: any) =>
    await genericApiCall({
      method: 'GET',
      endpoint: `${apiEndpoints.CANCEL_ORDER}${params}`,
    }),
  downloadShiprocketInvoice: async (params: any) =>
    await genericApiCall({
      method: 'GET',
      endpoint: `${apiEndpoints.DOWNLOAD_INVOICE}${params}`,
    }),
  shipmentTrackActivities: async (params: any) =>
    await genericApiCall({
      method: 'GET',
      endpoint: `${apiEndpoints.SHIPMENT_STATUS_TRACK}${params}`,
    }),
};

export default ApiUtils;
